// frontend/src/pages/TatmeenHierarchy/components/HierarchyForm.jsx

import React from "react";
import { Row, Col, Card, Select, Alert, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";

import SearchListAutoComplete from "../../../components/SearchListAutoComplete";

import {
  fetchVoucherList,
  fetchHierarchy,
} from "../hierarchyThunk";

// ✅ Import the new action
import { setSelectedReferenceId } from "../hierarchySlice";

const HierarchyForm = () => {
  const dispatch = useDispatch();

  const {
    vouchers = [],
    moduleType,
    loading,
    validation,
    summary,
  } = useSelector((state) => state.hierarchy);

  const handleModuleChange = (value) => {
    dispatch(fetchVoucherList(value));
  };

  const handleVoucherSelect = (obj) => {
    if (!obj || !obj.raw) return;

    const row = obj.raw;

    let referenceId = "";

    if (moduleType === "sales") {
      referenceId = row.sale_id;
    }

    if (moduleType === "sales_return") {
      referenceId = row.sale_r_id;
    }

    if (moduleType === "purchase_return") {
      referenceId = row.pur_r_id;
    }

    // ✅ Set selected reference ID in Redux
    dispatch(setSelectedReferenceId(referenceId));

    dispatch(
      fetchHierarchy({
        reference_type: moduleType,
        reference_id: referenceId,
      })
    );
  };

  return (
    <Card size="small">
      <Row gutter={16}>
        <Col span={8}>
          <Select
            style={{ width: "100%" }}
            placeholder="Select Module"
            value={moduleType}
            onChange={handleModuleChange}
            options={[
              {
                label: "Sales Entry",
                value: "sales",
              },
              {
                label: "Sales Return",
                value: "sales_return",
              },
              {
                label: "Purchase Return",
                value: "purchase_return",
              },
            ]}
          />
        </Col>

        <Col span={16}>
          <SearchListAutoComplete
            entityType="voucher"
            placeholder="Select Invoice"
            loading={loading}
            showAddNew={false}
            value={null}
            optionsList={vouchers.map((item) => ({
              display_text: item.display_text,
              raw: item,
            }))}
            onSelect={handleVoucherSelect}
          />
        </Col>
      </Row>

      {/* Quick Summary */}
      {summary && (
        <Row style={{ marginTop: 16 }}>
          <Col span={24}>
            <Space>
              <Tag color="geekblue">
                Total SSCCs: {summary.totalSSCCs}
              </Tag>
              {summary.hasParent && (
                <Tag color="blue">
                  Parent: {summary.parentSSCC?.code}
                </Tag>
              )}
              <Tag color="cyan">
                Children: {summary.childCount}
              </Tag>
              {summary.linkedCount !== undefined && (
                <Tag color="green">
                  Linked: {summary.linkedCount}
                </Tag>
              )}
            </Space>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default HierarchyForm;